export const FETCH_RULES = 'FETCH_RULES' // 规则集合
export const SET_HASID = 'SET_HASID' // 完成支付退回路由判断



// WEBPACK FOOTER //
// ./src/stores/rules/types.js